import type { BlogSocialLink } from '@jeraisonne/db';
import { BlogSocialReactions } from './blog-author';
import { BlogShareButton } from './blog-share-button';

interface BlogCompletionRewardProps {
  /** Titre de l'article (mis en avant dans le message de félicitations). */
  title: string;
  /** Réseaux où réagir / partager. */
  socialLinks: BlogSocialLink[];
}

/**
 * Carte « récompense » de fin de parcours, dévoilée une fois l'article
 * terminé. Porté depuis apps/marketing/src/components/blog-completion-reward.tsx.
 */
export function BlogCompletionReward({ title, socialLinks }: BlogCompletionRewardProps) {
  const shareText = `« ${title} » — un parcours de réflexion sur JeRaisonne`;
  return (
    <div className="border-primary-200 from-primary-50 to-level-100 bg-linear-to-br rounded-2xl border-2 via-white p-6 text-center shadow-sm">
      <span
        aria-hidden
        className="bg-primary-100 mx-auto mb-3 flex size-14 items-center justify-center rounded-full text-3xl shadow-sm"
      >
        🎉
      </span>
      <h2 className="text-xl font-bold text-gray-900">Bravo, tu as terminé ce parcours&nbsp;!</h2>
      <p className="mx-auto mt-2 max-w-md text-sm text-gray-600">
        «&nbsp;<span className="font-semibold text-gray-800">{title}</span>&nbsp;» t&apos;a fait
        réfléchir&nbsp;? Continue le débat avec les autres et partage ta réflexion.
      </p>
      <div className="mt-5 flex justify-center">
        {socialLinks.length > 0 ? (
          <BlogSocialReactions
            links={socialLinks}
            label="Continue le débat sur les réseaux"
            shareTitle={title}
            shareText={shareText}
          />
        ) : (
          <BlogShareButton title={title} text={shareText} />
        )}
      </div>
    </div>
  );
}
